"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _get(target, property, receiver) { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get; } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(receiver); } return desc.value; }; } return _get(target, property, receiver || target); }

function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var conversions = require("webidl-conversions");

var idlUtils = require("../generated/utils.js");

var ValidityState = require("../generated/ValidityState");

var DefaultConstraintValidationImpl = require("../constraint-validation/DefaultConstraintValidation-impl").implementation;

var _require = require("../../utils"),
    mixin = _require.mixin;

var HTMLElementImpl = require("./HTMLElement-impl").implementation;

var NODE_TYPE = require("../node-type");

var HTMLCollection = require("../generated/HTMLCollection");

var HTMLOptionsCollection = require("../generated/HTMLOptionsCollection");

var _require2 = require("../helpers/internal-constants"),
    domSymbolTree = _require2.domSymbolTree;

var _require3 = require("../helpers/form-controls"),
    getLabelsForLabelable = _require3.getLabelsForLabelable,
    formOwner = _require3.formOwner,
    isDisabled = _require3.isDisabled;

var _require4 = require("../helpers/strings"),
    parseNonNegativeInteger = _require4.parseNonNegativeInteger;

var HTMLSelectElementImpl = /*#__PURE__*/function (_HTMLElementImpl, _idlUtils$supportedPr, _idlUtils$indexedSetN, _idlUtils$indexedSetE) {
  _inherits(HTMLSelectElementImpl, _HTMLElementImpl);

  var _super = _createSuper(HTMLSelectElementImpl);

  function HTMLSelectElementImpl(globalObject, args, privateData) {
    var _this;

    _classCallCheck(this, HTMLSelectElementImpl);

    _this = _super.call(this, globalObject, args, privateData);
    _this._options = HTMLOptionsCollection.createImpl(_this._globalObject, [], {
      element: _assertThisInitialized(_this),
      query: function query() {
        // Customized domSymbolTree.treeToArray() clone.
        var array = [];

        var _iterator = _createForOfIteratorHelper(domSymbolTree.childrenIterator(_assertThisInitialized(_this))),
            _step;

        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var child = _step.value;

            if (child._localName === "option") {
              array.push(child);
            } else if (child._localName === "optgroup") {
              var _iterator2 = _createForOfIteratorHelper(domSymbolTree.childrenIterator(child)),
                  _step2;

              try {
                for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
                  var childOfGroup = _step2.value;

                  if (childOfGroup._localName === "option") {
                    array.push(childOfGroup);
                  }
                }
              } catch (err) {
                _iterator2.e(err);
              } finally {
                _iterator2.f();
              }
            }
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }

        return array;
      }
    });
    _this._selectedOptions = null; // lazy

    _this._customValidityErrorMessage = "";
    _this._labels = null;
    return _this;
  }

  _createClass(HTMLSelectElementImpl, [{
    key: "_formReset",
    value: function _formReset() {
      var _iterator3 = _createForOfIteratorHelper(this.options),
          _step3;

      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var option = _step3.value;
          option._selectedness = option.hasAttributeNS(null, "selected");
          option._dirtyness = false;
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }

      this._askedForAReset();
    }
  }, {
    key: "_askedForAReset",
    value: function _askedForAReset() {
      if (this.hasAttributeNS(null, "multiple")) {
        return;
      }

      var selected = this.options.filter(function (opt) {
        return opt._selectedness;
      });
      var size = this._displaySize;

      if (size === 1 && !selected.length) {
        // select the first option that is not disabled
        var _iterator4 = _createForOfIteratorHelper(this.options),
            _step4;

        try {
          for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
            var option = _step4.value;
            var disabled = option.hasAttributeNS(null, "disabled");
            var parentNode = domSymbolTree.parent(option);

            if (parentNode && parentNode.nodeName.toUpperCase() === "OPTGROUP" && parentNode.hasAttributeNS(null, "disabled")) {
              disabled = true;
            }

            if (!disabled) {
              // (do not set dirty)
              option._selectedness = true;
              break;
            }
          }
        } catch (err) {
          _iterator4.e(err);
        } finally {
          _iterator4.f();
        }
      } else if (selected.length >= 2) {
        // select the last selected option
        selected.forEach(function (option, index) {
          option._selectedness = index === selected.length - 1;
        });
      }
    }
  }, {
    key: "_descendantAdded",
    value: function _descendantAdded(parent, child) {
      if (child.nodeType === NODE_TYPE.ELEMENT_NODE) {
        this._askedForAReset();
      }

      _get(_getPrototypeOf(HTMLSelectElementImpl.prototype), "_descendantAdded", this).call(this, parent, child);
    }
  }, {
    key: "_descendantRemoved",
    value: function _descendantRemoved(parent, child) {
      if (child.nodeType === NODE_TYPE.ELEMENT_NODE) {
        this._askedForAReset();
      }

      _get(_getPrototypeOf(HTMLSelectElementImpl.prototype), "_descendantRemoved", this).call(this, parent, child);
    }
  }, {
    key: "_attrModified",
    value: function _attrModified(name, value, oldValue) {
      if (name === "multiple" || name === "size") {
        this._askedForAReset();
      }

      _get(_getPrototypeOf(HTMLSelectElementImpl.prototype), "_attrModified", this).call(this, name, value, oldValue);
    }
  }, {
    key: "_displaySize",
    get: function get() {
      if (this.hasAttributeNS(null, "size")) {
        var size = parseNonNegativeInteger(this.getAttributeNS(null, "size"));

        if (size !== null) {
          return size;
        }
      }

      return this.hasAttributeNS(null, "multiple") ? 4 : 1;
    }
  }, {
    key: "_mutable",
    get: function get() {
      return !isDisabled(this);
    }
  }, {
    key: "options",
    get: function get() {
      return this._options;
    }
  }, {
    key: "selectedOptions",
    get: function get() {
      var _this2 = this;

      return HTMLCollection.createImpl(this._globalObject, [], {
        element: this,
        query: function query() {
          return domSymbolTree.treeToArray(_this2, {
            filter: function filter(node) {
              return node._localName === "option" && node._selectedness === true;
            }
          });
        }
      });
    }
  }, {
    key: "selectedIndex",
    get: function get() {
      for (var i = 0; i < this.options.length; i++) {
        if (this.options.item(i)._selectedness) {
          return i;
        }
      }

      return -1;
    },
    set: function set(index) {
      for (var i = 0; i < this.options.length; i++) {
        this.options.item(i)._selectedness = false;
      }

      var selectedOption = this.options.item(index);

      if (selectedOption) {
        selectedOption._selectedness = true;
        selectedOption._dirtyness = true;
      }
    }
  }, {
    key: "labels",
    get: function get() {
      return getLabelsForLabelable(this);
    }
  }, {
    key: "value",
    get: function get() {
      var _iterator5 = _createForOfIteratorHelper(this.options),
          _step5;

      try {
        for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
          var option = _step5.value;

          if (option._selectedness) {
            return option.value;
          }
        }
      } catch (err) {
        _iterator5.e(err);
      } finally {
        _iterator5.f();
      }

      return "";
    },
    set: function set(val) {
      var _iterator6 = _createForOfIteratorHelper(this.options),
          _step6;

      try {
        for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
          var option = _step6.value;

          if (option.value === val) {
            option._selectedness = true;
            option._dirtyness = true;
          } else {
            option._selectedness = false;
          }

          option._modified();
        }
      } catch (err) {
        _iterator6.e(err);
      } finally {
        _iterator6.f();
      }
    }
  }, {
    key: "form",
    get: function get() {
      return formOwner(this);
    }
  }, {
    key: "type",
    get: function get() {
      return this.hasAttributeNS(null, "multiple") ? "select-multiple" : "select-one";
    }
  }, {
    key: _idlUtils$supportedPr,
    get: function get() {
      return this.options[idlUtils.supportedPropertyIndices];
    }
  }, {
    key: "length",
    get: function get() {
      return this.options.length;
    }
  }, {
    key: "length",
    set: function set(value) {
      this.options.length = value;
    }
  }, {
    key: "item",
    value: function item(index) {
      return this.options.item(index);
    }
  }, {
    key: "namedItem",
    value: function namedItem(name) {
      return this.options.namedItem(name);
    }
  }, {
    key: _idlUtils$indexedSetN,
    value: function value(index, _value) {
      return this.options[idlUtils.indexedSetNew](index, _value);
    }
  }, {
    key: _idlUtils$indexedSetE,
    value: function value(index, _value2) {
      return this.options[idlUtils.indexedSetExisting](index, _value2);
    }
  }, {
    key: "add",
    value: function add(opt, before) {
      this.options.add(opt, before);
    }
  }, {
    key: "remove",
    value: function remove(index) {
      if (arguments.length > 0) {
        index = conversions.long(index, {
          context: "Failed to execute 'remove' on 'HTMLSelectElement': parameter 1"
        });
        this.options.remove(index);
      } else {
        _get(_getPrototypeOf(HTMLSelectElementImpl.prototype), "remove", this).call(this);
      }
    }
  }, {
    key: "_barredFromConstraintValidationSpecialization",
    value: function _barredFromConstraintValidationSpecialization() {
      return this.hasAttributeNS(null, "readonly");
    } // Constraint validation: If the element has its required attribute specified,
    // and either none of the option elements in the select element's list of options
    // have their selectedness set to true, or the only option element in the select
    // element's list of options with its selectedness set to true is the placeholder
    // label option, then the element is suffering from being missing.

  }, {
    key: "validity",
    get: function get() {
      var _this3 = this;

      if (!this._validity) {
        var state = {
          valueMissing: function valueMissing() {
            if (!_this3.hasAttributeNS(null, "required")) {
              return false;
            }

            var selectedOptionIndex = _this3.selectedIndex;
            return selectedOptionIndex < 0 || selectedOptionIndex === 0 && _this3._hasPlaceholderOption;
          }
        };
        this._validity = ValidityState.createImpl(this._globalObject, [], {
          element: this,
          state: state
        });
      }

      return this._validity;
    } // If a select element has a required attribute specified, does not have a multiple attribute
    // specified, and has a display size of 1; and if the value of the first option element in the
    // select element's list of options (if any) is the empty string, and that option element's parent
    // node is the select element(and not an optgroup element), then that option is the select
    // element's placeholder label option.
    // https://html.spec.whatwg.org/multipage/form-elements.html#placeholder-label-option

  }, {
    key: "_hasPlaceholderOption",
    get: function get() {
      return this.hasAttributeNS(null, "required") && !this.hasAttributeNS(null, "multiple") && this._displaySize === 1 && this.options.length > 0 && this.options.item(0).value === "" && this.options.item(0).parentNode._localName !== "optgroup";
    }
  }]);

  return HTMLSelectElementImpl;
}(HTMLElementImpl, idlUtils.supportedPropertyIndices, idlUtils.indexedSetNew, idlUtils.indexedSetExisting);

mixin(HTMLSelectElementImpl.prototype, DefaultConstraintValidationImpl.prototype);
module.exports = {
  implementation: HTMLSelectElementImpl
};